// @flow
'use strict';

import * as React from 'react';

import type { IExpedidor } from '../types';
import { tipoDocumento } from './abas_informacoes';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';

type ExpedidorProps = {
  expedidor : IExpedidor,
};

export default function Expedidor({ expedidor } : ExpedidorProps) {
  if (!expedidor)
    return <h4 className="text-center" style={ { fontStyle: 'italic' } }>Nenhum expedidor informado no CT-e.</h4>

  return (
      <div className="tab-pane active">
        <h3>Expedidor</h3>
        <RowDetalhes data={ expedidor } className="no-margin-bottom">
          <ColumnDetalhes field="cnpj" type="documento" width="50%">{ tipoDocumento(expedidor) }</ColumnDetalhes>
          <ColumnDetalhes field="ie" width="50%">Inscrição Estadual</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ expedidor } className="no-margin-bottom">
          <ColumnDetalhes field="nomeRazaoSocial" width="50%">Nome / Razão Social</ColumnDetalhes>
          <ColumnDetalhes field="telefone" width="50%">Telefone</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ expedidor } className="no-margin-bottom">
          <ColumnDetalhes field="endereco" width="50%">Endereço</ColumnDetalhes>
          <ColumnDetalhes field="bairro" width="50%">Bairro</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ expedidor } className="no-margin-bottom">
          <ColumnDetalhes field="municipio" width="50%">Município</ColumnDetalhes>
          <ColumnDetalhes field="cep" type="cep" width="50%">CEP</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ expedidor } className="no-margin-bottom">
          <ColumnDetalhes field="uf" width="50%">UF</ColumnDetalhes>
          <ColumnDetalhes field="pais" width="50%">País</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ expedidor }>
          <ColumnDetalhes field="email" width="50%">E-mail</ColumnDetalhes>
        </RowDetalhes>
      </div>
  );
}
